/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Singapore_MottoInputs */

const en_singapore_motto = /** @type {(inputs: Singapore_MottoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Majulah Singapura!`)
};

const fr_singapore_motto = /** @type {(inputs: Singapore_MottoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Majulah Singapura!`)
};

const ms_sg2_singapore_motto = /** @type {(inputs: Singapore_MottoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Majulah Singapura!`)
};

/**
* | output |
* | --- |
* | "Majulah Singapura!" |
*
* @param {Singapore_MottoInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const singapore_motto = /** @type {((inputs?: Singapore_MottoInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Singapore_MottoInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_singapore_motto(inputs)
	if (locale === "fr") return fr_singapore_motto(inputs)
	return ms_sg2_singapore_motto(inputs)
});